import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

@Component({
  selector: 'app-tooltip-container',
  template: `
    <div class="tooltip-container">
      <ng-template #contentHost></ng-template>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipContainerComponent {
  @ViewChild('contentHost', { read: ViewContainerRef, static: true })
  contentHost!: ViewContainerRef;
}
